/**
 * Formats a phone number string by adding hyphens.
 * Supports 10 or 11 digit numbers.
 * @param {string} value - The phone number string to format
 * @returns {string} The formatted phone number
 */
/**
 * 숫자를 한국 원화 형식으로 포맷팅
 * @param {number|string} value - 숫자 값
 * @param {boolean|string} showUnit - true='원', '₩'='₩1,234', false=숫자만
 * @returns {string} "1,234원" 또는 "₩1,234" 또는 "1,234"
 */
export const formatPrice = (value, showUnit = true) => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (num == null || isNaN(num)) {
    if (showUnit === '₩') return '₩0';
    return showUnit ? '0원' : '0';
  }
  const formatted = num.toLocaleString('ko-KR');
  if (showUnit === '₩') return `₩${formatted}`;
  return showUnit ? `${formatted}원` : formatted;
};

export const formatPhoneNumber = (value) => {
  if (!value) return "";
  const numbers = value.replace(/[^\d]/g, "");
  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 7)
    return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
    7,
    11
  )}`;
};

/**
 * 날짜/시간을 'YYYY-MM-DD HH:mm:ss' 로 표시한다.
 *
 * 백엔드 LocalDateTime 은 "2026-08-27T17:32:44.879573" 처럼 T 구분자와 마이크로초를
 * 포함해 내려오는데, 그대로 화면에 뿌리면 읽기 어렵다.
 * Date 파싱에 의존하지 않고 문자열을 그대로 자른다 — 서버 시간이 KST 기준이고
 * 타임존 정보가 없어 new Date() 로 파싱하면 브라우저 로컬 타임존으로 재해석돼
 * 시간이 밀릴 수 있기 때문이다.
 *
 * @param {string} value ISO 형식 문자열
 * @param {boolean} withSeconds 초 표시 여부 (기본 true)
 */
export const formatDateTime = (value, withSeconds = true) => {
  if (!value) return '-';
  const str = String(value);
  const m = str.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})(:\d{2})?/);
  if (!m) return str;
  return withSeconds ? `${m[1]} ${m[2]}${m[3] || ':00'}` : `${m[1]} ${m[2]}`;
};

/** 날짜만 'YYYY-MM-DD' 로 표시 */
export const formatDate = (value) => {
  if (!value) return '-';
  const m = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : String(value);
};
